module.exports = __webpack_public_path__ + "static/media/location-icon.25c2765d.svg";